<template>
    <span :title="ago">{{ date.format(this.format) }}</span>
</template>

<script>
import moment from "moment";

export default {
    name: "date-format",
    props: {
        timestamp: Number,
        withTime: {
            default: true,
            type: Boolean,
        },
    },
    computed: {
        format() {
            if (this.withTime) {
                return window.bttb.dates.datetime;
            }

            return window.bttb.dates.date;
        },

        ago() {
            return this.date.fromNow();
        },

        date() {
            return moment.unix(this.timestamp).local();
        },
    }
}
</script>

<style scoped>

</style>
